import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import MainLogoLarge from "../assets/logo/codecube_tech_largeLogo.png";
import ContactForm from "./ContactForm"; // Add this import

export default function Nav() {
  const [open, setOpen] = useState(false);
  // const [scrolled, setScrolled] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
   const [isFormOpen, setIsFormOpen] = useState(false);
  const location = useLocation();



  useEffect(() => {
    setOpen(false);
  }, [location]);

    const handleGetStartedClick = () => {
    setIsFormOpen(true);
  };
  
  const handleMenuToggle = () => {
    if (open) {
      setIsClosing(true);
      document.body.classList.remove("menu-open");
      setTimeout(() => {
        setOpen(false);
        setIsClosing(false);
      }, 300);
    } else {
      setOpen(true);
      document.body.classList.add("menu-open");
    }
  };

  // Add this component above your Nav component
  const ServicesMobileSection = ({ onItemClick }) => {
    const [isServicesOpen, setIsServicesOpen] = useState(false);

    const toggleServices = () => {
      setIsServicesOpen(!isServicesOpen);
    };

    const serviceItemClass =
      "block px-6 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 border-l-4 border-transparent hover:border-blue-600";

    return (
      <div className="border-b border-gray-100 pb-2">
        {/* Services Header - Clickable */}
        <button
          onClick={toggleServices}
          className="flex items-center justify-between w-full px-4 py-3 rounded-lg text-base font-medium text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-300"
        >
          <span>Services</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            className={`w-5 h-5 transition-transform duration-300 ${
              isServicesOpen ? "rotate-180" : ""
            }`}
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        {/* Services Dropdown */}
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${
            isServicesOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="pl-2 py-2 space-y-1">
            <NavLink
              to="/services/web-development"
              className={serviceItemClass}
              onClick={onItemClick}
            >
              Web Development
            </NavLink>
            <NavLink
              to="/services/app-development"
              className={serviceItemClass}
              onClick={onItemClick}
            >
              App Development
            </NavLink>
            <NavLink
              to="/services/digital-marketing"
              className={serviceItemClass}
              onClick={onItemClick}
            >
              Digital Marketing
            </NavLink>
            <NavLink
              to="/services/it-support"
              className={serviceItemClass}
              onClick={onItemClick}
            >
              IT Support & Solutions
            </NavLink>
            <NavLink
              to="/services/cloud"
              className={serviceItemClass}
              onClick={onItemClick}
            >
              Cloud Services
            </NavLink>
          </div>
        </div>
      </div>
    );
  };

  const navLinkClass = ({ isActive }) =>
    `px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-blue-50 hover:text-blue-700 ${
      isActive ? "text-blue-600 font-bold" : "text-gray-700"
    }`;

  const mobileNavLinkClass = ({ isActive }) =>
    `px-4 py-3 rounded-lg text-base font-medium transition-all duration-300 hover:bg-blue-50 hover:text-blue-700 hover:translate-x-2 ${
      isActive
        ? "text-blue-600 font-semibold   bg-blue-50 border-l-4 border-purple-600"
        : "text-gray-700"
    }`;

  return (
    <>
    <header
      className='fixed top-0 w-full z-50 transition-all duration-300'
    >
      <div className='container py-3 lg:py-1 lg:w-[85%]  bg-green-50 backdrop-blur-3xl shadow-md lg:rounded-b-2xl  mx-auto px-4 sm:px-6 lg:px-8 '
      >
        <div className="flex  items-center justify-between">
          <div className="flex items-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 hover:scale-105 transition-transform duration-300"
            >
              <img
                src={MainLogoLarge}
                className="lg:h-8 h-8"
                alt="Codecube Technology"
              />
            </Link>
          </div>

          <nav className="hidden text-lg lg:flex  items-center gap-1">
            <NavLink to="/" className={navLinkClass} end>
              Home
            </NavLink>
            <NavLink to="/about" className={navLinkClass}>
              About
            </NavLink>

            {/* Services Dropdown */}
            <div className="relative group">
              <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-blue-50 hover:text-blue-700 text-gray-700 flex items-center gap-1">
                Services
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-4 h-4 transition-transform duration-300 group-hover:rotate-180"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-white/95 backdrop-blur-lg rounded-xl shadow-2xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform origin-top-left scale-95 group-hover:scale-100">
                <div className="py-2">
                  <NavLink
                    to="/services/web-development"
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 border-l-4 border-transparent hover:border-blue-600"
                  >
                    Web Development
                  </NavLink>
                  <NavLink
                    to="/services/app-development"
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 border-l-4 border-transparent hover:border-blue-600"
                  >
                    App Development
                  </NavLink>
                  <NavLink
                    to="/services/digital-marketing"
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 border-l-4 border-transparent hover:border-blue-600"
                  >
                    Digital Marketing
                  </NavLink>
                  <NavLink
                    to="/services/it-support"
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 border-l-4 border-transparent hover:border-blue-600"
                  >
                    IT Support & Solutions
                  </NavLink>
                  <NavLink
                    to="/services/cloud"
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 border-l-4 border-transparent hover:border-blue-600"
                  >
                    Cloud Services
                  </NavLink>
                </div>
              </div>
            </div>

            <NavLink to="/portfolio" className={navLinkClass}>
              Portfolio
            </NavLink>
            <NavLink to="/vision" className={navLinkClass}>
              Vision
            </NavLink>
            <NavLink to="/careers" className={navLinkClass}>
              Careers
            </NavLink>
            {/* <NavLink to="/blog" className={navLinkClass}>
              Blog
            </NavLink> */}
            <NavLink to="/contact" className={navLinkClass}>
              Contact
            </NavLink>
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link
               onClick={handleGetStartedClick}
              className="inline-flex items-center rounded-full bg-gradient-to-r from-blue-600 to-purple-600 px-4 py-1.5 text-sm font-semibold text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              Get a Quote?
            </Link>
          </div>

          <button
            aria-label="Toggle menu"
            className="lg:hidden inline-flex items-center justify-center rounded-lg bg-white/5 p-2 text-indigo-700 hover:bg-gray-100 shadow-sm transition-all duration-300 hover:scale-105"
            onClick={handleMenuToggle}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="h-6 w-6"
            >
              {open ? (
               <path
                  fillRule="evenodd"
                  d="M3.75 5.25a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75zm0 6a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75zm0 6a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75z"
                  clipRule="evenodd"
                />
              ) : (
                <path
                  fillRule="evenodd"
                  d="M3.75 5.25a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75zm0 6a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75zm0 6a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75z"
                  clipRule="evenodd"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu with Animation */}
      <div
        className={`lg:hidden fixed inset-0 z-40 transition-all duration-300 ease-in-out ${
          open ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        {/* Backdrop */}
        <div
          className={`absolute inset-0 bg-black transition-opacity duration-300 ${
            open && !isClosing ? "opacity-50" : "opacity-0"
          }`}
          onClick={handleMenuToggle}
        />

        {/* Menu Drawer */}
        <div
          className={`absolute top-0 left-0 h-screen w-full max-w-sm bg-white backdrop-blur-lg shadow-2xl border-r border-gray-200 transform transition-transform duration-300 ease-in-out ${
            open && !isClosing ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-100">
            <Link
              to="/"
              className="inline-flex items-center gap-2"
              onClick={() => setOpen(false)}
            >
              <img
                src={MainLogoLarge}
                className="h-10"
                alt="Codecube Technology"
              />
            </Link>
            <button
              aria-label="Close menu"
              className="p-2 rounded-lg text-indigo-700  hover:bg-gray-100 bg-white shadow-sm transition-all duration-300 hover:scale-110"
              onClick={handleMenuToggle}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-6 w-6"
              >
                <path
                  fillRule="evenodd"
                  d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 11-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          {/* Navigation Links - Scrollable Container */}
          <div className="h-[calc(100vh-80px)] overflow-y-auto">
            <nav className="flex flex-col p-4 space-y-1">
              <NavLink
                to="/"
                className={mobileNavLinkClass}
                end
                onClick={handleMenuToggle}
              >
                Home
              </NavLink>
              <NavLink
                to="/about"
                className={mobileNavLinkClass}
                onClick={handleMenuToggle}
              >
                About
              </NavLink>

              {/* Services Section with Collapsible */}
              <ServicesMobileSection onItemClick={handleMenuToggle} />

              <NavLink
                to="/portfolio"
                className={mobileNavLinkClass}
                onClick={handleMenuToggle}
              >
                Portfolio
              </NavLink>
              <NavLink
                to="/vision"
                className={mobileNavLinkClass}
                onClick={handleMenuToggle}
              >
                Vision
              </NavLink>
              <NavLink
                to="/careers"
                className={mobileNavLinkClass}
                onClick={handleMenuToggle}
              >
                Careers
              </NavLink>
              {/* <NavLink
                to="/blog"
                className={mobileNavLinkClass}
                onClick={handleMenuToggle}
              >
                Blog
              </NavLink> */}
              <NavLink
                to="/contact"
                className={mobileNavLinkClass}
                onClick={handleMenuToggle}
              >
                Contact
              </NavLink>
            </nav>

            {/* CTA Button */}
            <div className="sticky bottom-0 bg-white border-t border-gray-100 p-4">
              <Link
                onClick={handleGetStartedClick}
                className="inline-flex w-full items-center justify-center rounded-full bg-gradient-to-r from-blue-600 to-purple-600 px-4 py-3 text-sm font-semibold text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
      <ContactForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    
    </>
  );
}
